export default function Go_Certificate () {
  return (
    <div>
      <h1>Go_Certificate </h1>
      <p>Go Certificate</p>
    </div>
  );
}